// Display labels for testset keys returned by the evaluation APIs.
const TESTSET_LABELS = {
    internal: 'Internal',
    esc50: 'ESC-50',
    dcase2018_task2: 'DCASE2018-Task2',
    urbansound8k: 'UrbanSound8K',
    fsd50k: 'FSD50K',
}

export const testsetLabel = (testset) => TESTSET_LABELS[testset] || testset
